// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Link: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M34.3 29.3c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c2.1 0 4-1 5.3-2.6l.1-.2 9.6-9.6c.8-1.1 1.3-2.5 1.2-3.9 0-1.8-.7-3.4-1.9-4.6-1.2-1.2-2.9-1.9-4.6-1.9-1.4 0-2.7.4-3.9 1.3L29.7 15.1c-1.3 1.3-2 2.9-2 4.6 0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-2.4 1-4.8 2.8-6.7L38.2 2.4C39.9 1.1 41.9.5 43.9.5c2.6 0 5 1 6.8 2.8 1.8 1.8 2.8 4.2 2.8 6.8 0 2.1-.7 4.1-1.9 5.7l-.1.2-9.6 9.6c-1.9 2.3-4.6 3.7-7.6 3.7zM10.1 53.5c-2.6 0-5-1-6.8-2.8C1.5 48.9.5 46.5.5 43.9c0-2.4 1-4.8 2.8-6.7L14 26.6c1.7-1.3 3.7-1.9 5.7-1.9.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5c-1.4 0-2.7.4-3.9 1.3L5.5 39.4c-1.3 1.3-2 2.9-2 4.6 0 1.8.7 3.4 1.9 4.6 1.2 1.2 2.9 1.9 4.6 1.9 2.1 0 4-1 5.3-2.6l.1-.2 9.6-9.6c.8-1.1 1.3-2.5 1.3-3.9 0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 2.1-.7 4.1-1.9 5.7l-.1.2-9.6 9.6c-1.9 2.5-4.6 3.8-7.6 3.8zm16.1-14.4z"/><path d="M19.7 35.8c-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.5 0-2.1l14.5-14.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1L20.8 35.3c-.3.3-.7.5-1.1.5z"/></svg>;
};

export default React.memo(Link);
